import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'
import Home from '@/components/Home'
import Product from '@/components/Product'
import ProductDetail from '@/components/ProductDetail'
import Xjdetail from '@/components/Xjdetail'
import PlanDetail from '@/components/PlanDetail'
import Cpxd from '@/components/Cpxd'
import Notice from '@/components/Notice'
import NoticeDetail from '@/components/NoticeDetail'
import About from '@/components/About'

import Register from '@/components/Register'
import Login from '@/components/Login'
import Order from '@/components/Order'
import OrderInfo from '@/components/OrderInfo'
import Kaoshi from '@/components/Kaoshi'
import PlanKs from '@/components/PlanKs'
import Ready from '@/components/Ready'
import Ckjx from '@/components/Ckjx'
import Forensics from '@/components/Forensics'

import Learning from '@/components/Learning'
import Mytask from '@/components/xueyuan/Mytask'
import Mykaoshi from '@/components/xueyuan/Mykaoshi'
import Mucurse from '@/components/xueyuan/Mucurse'
import WronCard from '@/components/xueyuan/WronCard'
import Historical from '@/components/xueyuan/Historical'
import Myorder from '@/components/xueyuan/Myorder'
import Certificate from '@/components/xueyuan/Certificate'
import Personal from '@/components/xueyuan/Personal'
import reerror from '@/components/xueyuan/reerror'
import Selectkcxs from '@/components/xueyuan/Selectkcxs'

import Company from '@/components/Company'
import ComHome from '@/components/company/ComHome'
import updatePass from '@/components/company/updatePass'
import UserList from '@/components/company/UserList'
import UserInfo from '@/components/company/UserInfo'
import UserFile from '@/components/company/UserFile'
import Plan from '@/components/company/Plan'
import PlanInfo from '@/components/company/PlanInfo'
import BuyCurriculum from '@/components/company/BuyCurriculum'
import MyCurriculum from '@/components/company/MyCurriculum'
import OrderTask from '@/components/company/OrderTask'
import CompanyInfo from '@/components/company/CompanyInfo'
import CurseInfo from '@/components/company/CurseInfo'
import Mingxi from '@/components/company/Mingxi'
import CurriculumInfo from '@/components/company/CurriculumInfo'
import ArchivesInfo from '@/components/company/ArchivesInfo'
import DeviceInfo from '@/components/company/DeviceInfo'
import Enterprise from '@/components/company/Enterprise'
import System from '@/components/company/System'
import Examination from '@/components/company/Examination'
import Addprice from '@/components/company/Addprice'
import Addexam from '@/components/company/Addexam'
import Addtest from '@/components/company/Addtest'
import Pxpg from '@/components/company/Pxpg'
import Pxbaogao from '@/components/company/Pxbaogao'

import GwList from '@/components/company/GwList'
import Addgw from '@/components/company/Addgw'

import stadyList from '@/components/company/stadyList'

import YlPay from '@/components/YlPay'
import testQuestion from '@/components/testQuestion'

import printPlaninfo from '@/components/printPlaninfo'

import sbsda from '@/components/sbsda'
import sbsDetail from '@/components/sbsDetail'
import flow from '@/components/flow'

import loadlogin from '@/components/loadlogin'
Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'Main',
      component: Main,
      children: [{
          path: '/',
          name: 'Learning',
          component: Learning,
          meta: {
            index: 4
          }, //meta对象的index用来定义当前路由的层级,由小到大,由低到高
          children: [{
              path: '/',
              name: 'Mucurse',
              component: Mucurse,
            }]
        },{
          path: '/Learning',
          name: 'Learning',
          component: Learning,
          meta: {
            index: 4
          }, //meta对象的index用来定义当前路由的层级,由小到大,由低到高
          children: [{
              path: '/Learning/',
              name: 'Mucurse',
              component: Mucurse,
            },
            {
              path: '/Learning/Mucurse',
              name: 'Mucurse',
              component: Mucurse,
            },
            {
              path: '/Learning/Mytask',
              name: 'Mytask',
              component: Mytask,
            },
            {
              path: '/Learning/Mykaoshi',
              name: 'Mykaoshi',
              component: Mykaoshi,
            },
            {
              path: '/Learning/Myjiexi',
              name: 'Myjiexi',
              component: Ckjx
            },
            {
              path: '/Learning/WronCard',
              name: 'WronCard',
              component: WronCard,
            },
            {
              path: '/Learning/Historical',
              name: 'Historical',
              component: Historical,
            },
            {
              path: '/Learning/Myorder',
              name: 'Myorder',
              component: Myorder,
            },
            {
              path: '/Learning/Certificate',
              name: 'Certificate',
              component: Certificate,
            },
            {
              path: '/Learning/Personal',
              name: 'Personal',
              component: Personal,
            },
            {
              path: '/Learning/Selectkcxs',
              name: 'Selectkcxs',
              component: Selectkcxs
            }
          ]
        },
        {
          path: '/Home',
          name: 'Home',
          component: Home,
          meta: {
            index: 0
          }, //meta对象的index用来定义当前路由的层级,由小到大,由低到高
        },
        {
          path: '/Product',
          name: 'Product',
          component: Product,
          meta: {
            index: 1
          }, //meta对象的index用来定义当前路由的层级,由小到大,由低到高
        },
        {
          path: '/ProductDetail',
          name: 'ProductDetail',
          component: ProductDetail,
          meta: {
            index: 1
          }, //meta对象的index用来定义当前路由的层级,由小到大,由低到高
        },
        {
          path: '/Xjdetail',
          name: 'Xjdetail',
          component: Xjdetail,
          meta: {
            index: 1
          }, //meta对象的index用来定义当前路由的层级,由小到大,由低到高
        },
        {
          path: '/PlanDetail',
          name: 'PlanDetail',
          component: PlanDetail,
          meta: {
            index: 1
          }, //meta对象的index用来定义当前路由的层级,由小到大,由低到高
        },
        {
          path: '/testQuestion',
          name: 'testQuestion',
          component: testQuestion,
          meta: {
            index: 2
          }, //meta对象的index用来定义当前路由的层级,由小到大,由低到高
        },
        {
          path: '/reerror',
          name: 'reerror',
          component: reerror,
        },
        {
          path: '/Order',
          name: 'Order',
          component: Order,
          meta: {
            index: 1
          }, //meta对象的index用来定义当前路由的层级,由小到大,由低到高
        },
        {
          path: '/OrderInfo',
          name: 'OrderInfo',
          component: OrderInfo,
          meta: {
            index: 1
          }, //meta对象的index用来定义当前路由的层级,由小到大,由低到高
        },
        {
          path: '/Notice',
          name: 'Notice',
          component: Notice,
          meta: {
            index: 3
          }, //meta对象的index用来定义当前路由的层级,由小到大,由低到高
        },
        {
          path: '/sbsda',
          name: 'sbsda',
          component: sbsda,
          meta: {
            index: 3
          }, //meta对象的index用来定义当前路由的层级,由小到大,由低到高
        },
        {
          path: '/sbsDetail',
          name: 'sbsDetail',
          component: sbsDetail,
          meta: {
            index: 4
          }, //meta对象的index用来定义当前路由的层级,由小到大,由低到高
        },
        {
          path: '/flow',
          name: '/flow',
          component: flow,
          meta: {
            index: 3
          }, //meta对象的index用来定义当前路由的层级,由小到大,由低到高
        },
        {
          path: '/NoticeDetail',
          name: 'NoticeDetail',
          component: NoticeDetail,
          meta: {
            index: 4
          }, //meta对象的index用来定义当前路由的层级,由小到大,由低到高
        },
        {
          path: '/Forensics',
          name: 'Forensics',
          component: Forensics,
          meta: {
            index: 2
          }, //meta对象的index用来定义当前路由的层级,由小到大,由低到高
        },
        {
          path: '/About',
          name: 'About',
          component: About,
          meta: {
            index: 3
          }, //meta对象的index用来定义当前路由的层级,由小到大,由低到高
        },
        {
          path: '/Company',
          name: 'Company',
          component: Company,
          meta: {
            index: 4
          },
          children: [{
              path: '/Company/',
              name: 'ComHome',
              component: ComHome,
            },
            {
              path: '/Company/GwList',
              name: 'GwList',
              component: GwList,
            },
            {
              path: '/Company/Addgw',
              name: 'Addgw',
              component: Addgw,
            },
            {
              path: '/Company/updatePass',
              name: 'updatePass',
              component: updatePass,
            },
            {
              path: '/Company/ComHome',
              name: 'ComHome',
              component: ComHome,
            },
            {
              path: '/Company/UserList',
              name: 'UserList',
              component: UserList,
            },
            {
              path: '/Company/ArchivesInfo',
              name: 'ArchivesInfo',
              component: ArchivesInfo,
            },
            {
              path: '/Company/UserInfo',
              name: 'UserInfo',
              component: UserInfo,
            },
            {
              path: '/Company/UserFile',
              name: 'UserFile',
              component: UserFile,
            },
            {
              path: '/Company/BuyCurriculum',
              name: 'BuyCurriculum',
              component: BuyCurriculum,
            },
            {
              path: '/Company/CurseInfo',
              name: 'CurseInfo',
              component: CurseInfo,
            },
            {
              path: '/Company/Mingxi',
              name: 'Mingxi',
              component: Mingxi,
            },
            {
              path: '/Company/MyCurriculum',
              name: 'MyCurriculum',
              component: MyCurriculum,
            },
            {
              path: '/Company/CurriculumInfo',
              name: 'CurriculumInfo',
              component: CurriculumInfo,
            },
            {
              path: '/Company/Plan',
              name: 'Plan',
              component: Plan,
            },
            {
              path: '/Company/DeviceInfo',
              name: 'DeviceInfo',
              component: DeviceInfo,
            },
            {
              path: '/Company/Enterprise',
              name: 'Enterprise',
              component: Enterprise,
            },
            {
              path: '/Company/Addprice',
              name: 'Addprice',
              component: Addprice,
            },
            {
              path: '/Company/Addexam',
              name: 'Addexam',
              component: Addexam,
            },
            {
              path: '/Company/Addtest',
              name: 'Addtest',
              component: Addtest,
            },
            {
              path: '/Company/Pxpg',
              name: 'Pxpg',
              component: Pxpg,
            },
            {
              path: '/Company/Pxbaogao',
              name: 'Pxbaogao',
              component: Pxbaogao,
            },
            {
              path: '/Company/stadyList',
              name: 'stadyList',
              component: stadyList,
            },
            {
              path: '/Company/System',
              name: 'System',
              component: System,
            },
            {
              path: '/Company/Examination',
              name: 'Examination',
              component: Examination,
            },
            {
              path: '/Company/PlanInfo',
              name: 'PlanInfo',
              component: PlanInfo,
            },
            {
              path: '/Company/OrderTask',
              name: 'OrderTask',
              component: OrderTask,
            },
            {
              path: '/Company/CompanyInfo',
              name: 'CompanyInfo',
              component: CompanyInfo,
            },
          ]
        },
      ]
    },
    {
      path: '/Register',
      name: 'Register',
      component: Register,
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/Cpxd',
      name: 'Cpxd',
      component: Cpxd,
    },
    {
      path: '/printPlaninfo',
      name: 'printPlaninfo',
      component: printPlaninfo,
    },
    {
      path: '/loadlogin',
      name: 'loadlogin',
      component: loadlogin,
    },
    {
      path: '/YlPay',
      name: 'YlPay',
      component: YlPay,
    },
    {
      path: '/Kaoshi',
      name: 'Kaoshi',
      component: Kaoshi,
    },
    {
      path: '/PlanKs',
      name: 'PlanKs',
      component: PlanKs,
    },
    {
      path: '/Ready',
      name: 'Ready',
      component: Ready,
    },
    {
      path: '/Ckjx',
      name: 'Ckjx',
      component: Ckjx
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js